import "./whatsapp.css";

const Whatsapp = () => {
  return (
    <div>
      {/* WhatsApp icon */}
      <a
        href="https://wa.me/96171400777"
        className="whatsapp_float"
        target="_blank"
        rel="noopener noreferrer"
        title="whatsapp"
      >
        <i className="fa fa-whatsapp whatsapp-icon"></i>
      </a>
    </div>
  );
};
export default Whatsapp;
